import React, { Component } from 'react';
import '../../css/admin/ComponenteSpinner.css';
import {Spinner} from 'react-bootstrap';
import { memo } from 'react';

export class ComponenteSpinner extends Component {
    render() {

    return (
        <div className="admin-spinner">
            <Spinner animation="border" variant="primary" >
            </Spinner>
        <span className='admin-spinner-span'>Cargando...</span>
   </div>
    );
  }
}

export default memo(ComponenteSpinner);
